import { useTheme } from "../context/ThemeContext";
import { Sun, Moon } from "lucide-react";

const ThemeToggle = () => {
  const { theme, toggleTheme } = useTheme();

  return (
    <button
      onClick={toggleTheme}
      className="relative w-14 h-7 rounded-full p-1 transition-colors duration-300 focus:outline-none focus:ring-2 focus:ring-yellow-500/50"
      style={{
        background: theme === "dark" 
          ? "linear-gradient(135deg, #1e1b4b, #312e81)" 
          : "linear-gradient(135deg, #fbbf24, #f59e0b)"
      }}
      data-testid="theme-toggle"
      aria-label={`Switch to ${theme === "dark" ? "light" : "dark"} mode`}
    >
      {/* Toggle Circle */}
      <div
        className={`absolute top-1 w-5 h-5 rounded-full bg-white shadow-md transform transition-transform duration-300 flex items-center justify-center ${
          theme === "dark" ? "left-1" : "left-8"
        }`}
      >
        {theme === "dark" ? (
          <Moon size={12} className="text-indigo-600" />
        ) : (
          <Sun size={12} className="text-amber-500" />
        )}
      </div>
      
      {/* Background Icons */}
      <div className="flex justify-between items-center h-full px-1">
        <Sun size={12} className={`text-white/50 ${theme === "light" ? "opacity-0" : "opacity-100"} transition-opacity`} />
        <Moon size={12} className={`text-white/50 ${theme === "dark" ? "opacity-0" : "opacity-100"} transition-opacity`} />
      </div>
    </button>
  );
};

export default ThemeToggle;
